export default {
    footerText: 'Ready to get going with Campfire?',
    footerEmailInputPlaceholder: 'Your email address',
    footerEmailInputButton: 'Get a demo',
    footerEmailSubtext: "We'll schedule a time that works for you",
    footerConfirmed: "Thank you! We'll reach out shortly to"
}